import { HSformGuids, HSEndpoints, jsonHeader } from '../common/constants';

/**
 *
 * @param fields is a object with key value pairs e.g. {email: '', firstname: '', lastname: ''}
 * email is required. This form is submitted for Public cloud only
 */
export async function sendTrialSignupFormDataToHubspot(fields: any, pageName: string) {
    try {
        const formLocale = fields.user_locale === 'de' ? 'de' : 'en';
        // TODO: Question: How do we know in Credentials Landing that it is private or public cloud?
        // TODO: How should name be stored in HS, if we store name in one field only
        const nameParts = fields.displayName?.split(' ') ?? [];
        const [firstName, ...lastName] = nameParts;
        let hubspotFields: any = {
            is_business: fields.isBusiness,
            email: fields.email,
            firstname: firstName,
            lastname: lastName.join(' '),
            company: fields.company,
            numemployees: fields.businessSize,
            country_ninox: fields.country,
            hs_language: fields.user_locale,
            sign_up_phone: fields.telephone,
            markeing_email_active: fields.marketing,
            marketing_email_active_2: fields.marketing,
            // only update this field, if this is the first step in the signup process, not in the second step (for business signup)
            status: 'isBusiness' in fields ? 'unconfirmed' : null
        };

        // remove null fields
        hubspotFields = Object.entries(hubspotFields)
            .map(([key, value]) => ({
                objectTypeId: 'contact',
                name: key,
                value
            }))
            .filter((field) => field.value != null && field.value !== '');

        const payload = {
            context: {
                hutk: getCookie('hubspotutk'),
                pageUri: window.location.href,
                pageName: pageName
            },
            fields: hubspotFields
        };
        const response = await fetch(`${HSEndpoints.forms}/${HSformGuids.trialSignupForms[formLocale]}`, {
            method: 'POST',
            headers: jsonHeader,
            body: JSON.stringify(payload)
        });

        return response;
    } catch (err) {
        console.warn(err);

        return null;
    }
}

// get cookie hubspotutk
function getCookie(name: string) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);

    if (parts.length === 2) return parts?.pop()?.split(';')?.shift();

    return;
}
